import { EdgePanel } from "@pax/ui";
import { AccountPane } from "./AccountBody";

/**
 * Your account on a phone, where there is no room beside anything.
 *
 * It comes up from the foot over an app that has stepped back to let it,
 * which is the arrival every other screen makes down here. That makes it a
 * dialog in every way that matters — it takes the keyboard, Escape and the
 * scrim close it, and nothing behind it can be reached — so it is one.
 */
export function AccountSheet({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <EdgePanel
      open={open}
      onOpenChange={onOpenChange}
      title="Account"
      className="inset-x-0 top-(--sheet-top) bottom-0 rounded-t-(--sheet-radius)"
    >
      <AccountPane onClose={() => onOpenChange(false)} />
    </EdgePanel>
  );
}
